import React,{useState} from 'react';
import classNames from 'classnames';

function PasswordInput({ value, onChange, style, classname, error,label } ) { 
  const [ showPassword, setShowPassword ] = useState( false );

  return (
    <div className={ classNames( 'text-input', classname ) } style={ style }>
      <label className="label" >{label || 'كلمة المرور'}</label>
      <div className={ error && 'error' }>
        <input type={showPassword?'text':'password'} value={ value } onChange={ onChange } placeholder="********"/>
        {!showPassword ? <i className="fa fa-eye password_icon" onClick={ () => { setShowPassword( !showPassword ); } }></i> 
        : <i className="fa fa-eye-slash password_icon" onClick={ () => { setShowPassword( !showPassword ); } }></i> }
      </div>
      { error && <span className="error-message">{ error }</span> }
    </div >
  );
    
}

export default PasswordInput;